// extracted by mini-css-extract-plugin
export var quillEditor = "_mv-1";
export var variable = "_mv-0";